import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { firstValueFrom } from 'rxjs';
import { saveAs } from 'file-saver';
import { IOrdersByWeeksReportFilter, IOrdersReportFilter } from 'app/models/report.model';
import { UnhandledException } from 'app/constants/notification-messages';

@Injectable({
  providedIn: 'root',
})
export class ApiReportService {
  private headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  constructor(private http: HttpClient) {
  }

  public async GetOrdersReport(ordersReportFilter: IOrdersReportFilter)
  {
    const reportUrl = `${environment.baseUrl}/api/report/orders`;

    try {
      const responseBlob = await firstValueFrom(
        this.http.post(
          reportUrl,
          ordersReportFilter,
          {
            headers: this.headers,
            responseType: 'blob',
            observe: 'response',
          }));

      saveAs(responseBlob.body, 'order_report.xlsx');
    }
    catch (error) {
      alert(UnhandledException);
    }
  }

  public async GetOrdersByWeeksReport(ordersByWeekReportFilter: IOrdersByWeeksReportFilter)
  {
    const reportUrl = `${environment.baseUrl}/api/report/orders-by-weeks`;

    try {
      const responseBlob = await firstValueFrom(
        this.http.post(
          reportUrl,
          ordersByWeekReportFilter,
          {
            headers: this.headers,
            responseType: 'blob',
            observe: 'response',
          }));

      saveAs(responseBlob.body, `orders_by_weeks_report_${ordersByWeekReportFilter.finishDay}.xlsx`);
    }
    catch (error) {
      alert(UnhandledException);
    }
  }
}
